import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

Sentry.init({
  dsn: "https://d2699a5c1c47aef0d9514178727ce407@o4509921502035968.ingest.de.sentry.io/4509921504723024",
  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ["error"] }),
  ],
  enableLogs: true,
});

createRoot(document.getElementById("root")!).render(<App />);
